module.exports = __webpack_public_path__ + "static/img/poster_4.f67509b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_10/poster_4.jpg
// module id = 6/nB
// module chunks = 0